module.exports = __webpack_public_path__ + "static/media/eventbooking.60ccc871.webp";